// extracted by mini-css-extract-plugin
export default {"verifiedOld":"verified-badge_verifiedOld__+G7ob","verifiedBlue":"verified-badge_verifiedBlue__C6GdC","verifiedGovernment":"verified-badge_verifiedGovernment__upLhP"};